<template>
  <app-layout ref="appLayout">
    <template v-slot:submenu>
      <sub-menu>
        <router-link :to="{ name: 'ListSites' }" class="btn btn-outline-dark">
          <show-icon name="site" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline align-middle">&nbsp;{{ t('models.site', 2) }}</span>
        </router-link>
      </sub-menu>      
    </template>

    <template v-slot:default>

      <page-header icon="download">
        <h4 class="lh-1 m-0">{{ t('import_sites') }}</h4>
      </page-header>      

      <div class="row mb-3">
        <div class="col-6">
          <label for="name" class="float-left">{{ t("attributes.site.company") }}</label>
          <div class="input-group">
            <!--select name="company_uuid" ref="company_uuid" class="form-select" id="company_uuid"-->
            <select v-model="company_uuid" class="form-select">
              <option></option>
              <option v-for="company in companies" :key="company.uuid" :value="company.uuid">
                {{ company.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-6">
          <label class="float-left">&nbsp;</label>
          <div class="input-group" v-if="company_uuid">
            <button class="btn btn-outline-dark" @click="onListCompanySites">
              <show-icon name="sync" size="sm" class="align-middle"></show-icon>
              {{ t('list_sites') }}
            </button>            
          </div>
        </div>

        <div class="col-6" v-if="hasSomeSites">
          <label for="name" class="float-left">{{ t("filter") }}</label>
          <div class="input-group">
            <input type="text" v-model="site_name_filter" class="form-control">
          </div>          
        </div>        
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <ul class="list-group">
            <li v-for="site in siteList()" :key="site.uuid" class="list-group-item">
              <div class="float-start">
                <b>{{ site.name }}</b>
                <div class="small">{{ fullSiteAddress(site) }}</div>
              </div>
              <button v-if="isLocalSite(site)" class="btn btn-outline-dark float-end" @click="onClickedSync(site.uuid)">
                <show-icon name="sync" size="sm" class="align-middle"></show-icon>
              </button>
              <button v-else class="btn btn-outline-dark float-end" @click="onDownloadSite(site.uuid)">
                <show-icon name="download" size="sm" class="align-middle"></show-icon>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </app-layout>
</template>

<script>
import { ref, computed } from 'vue';  
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'

import { errMsg } from '@/common/error_msg_helper';
import SiteService from '@/services/SiteService';
import { authenticated } from '@/common/user_helpers';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n({ useScope: 'global' });

    const companies = computed(function() {
      return store.getters.getAllCompanies;
    });

    const company_uuid = (companies.value.length == 1) ? ref(companies.value[0].uuid) : ref(null);
    const sites = ref([])
    const site_name_filter = ref("")

    const hasSomeSites = computed(function() {
      return (sites.value.length > 0)
    });

    // returns true if the site is already in local storage
    const isLocalSite = function(site) {
      return store.getters.getSite(site.uuid);
    }

    const onClickedSync = function(site_uuid) {
      router.push({ name: 'SyncSite', params: { id: site_uuid }});
    }

    const onDownloadSite = function(site_uuid) {
      console.log("Inside SiteImport.vue, onDownloadSite, site_uuid ==> ", site_uuid)
      router.push({ name: 'ImportSite', params: { site_id: site_uuid }, query: { company_id: company_uuid.value }});
    }
    
    const siteList = function() {
      if (site_name_filter.value) {
        // if a site name filter is given, filter the sites with matching name
        return sites.value.filter(function(site) {
          // make sure it's case insensitive
          return site.name.toLowerCase().includes(site_name_filter.value.toLowerCase());
        });
      } else {
        // return all sites
        return sites.value;
      }
    }

    return {
      companies,
      company_uuid,
      sites,
      site_name_filter,
      hasSomeSites,
      isLocalSite,
      onClickedSync,
      onDownloadSite,
      siteList,
      t
    }
  },
  mounted() {
    // make sure the user is login before proceed to import site
    if (!authenticated()) {
      this.$refs.appLayout.goLogin(function(user) {
        console.log("Inside site/SiteSelectImport.vue, mounted(), after successful login, user ==> ", user);
        // reload this page
        this.$router.push({ name: 'SelectImportSite' })
      });      
    }
  },  
  emits: [
    "requires-login"
  ],  
  computed: {

  },
  methods: {
    onListCompanySites() {
      const promise = SiteService.getSites(this.company_uuid);
      const thisHandle = this;
      promise.then(function(result) {
        thisHandle.sites = result;
      }).catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx

          if (error.response.status == 401) {
            // session expired or not login at all, trigger the login box
            thisHandle.$refs.appLayout.goLogin(function(user) {
              console.log("Inside site/SiteSelectImport.vue, onListCompanySites(), after successful login, user ==> ", user);
              // recursively call myself to retry sync site
              this.$router.push({ name: 'SelectImportSite' })
            });

          } else if (error.response.status == 403) {
            // user has no access right to the AIMS2GO API
            alert(thisHandle.t("errors.site.sync_import") + " : User has no access right. Please contact admin");
          } else {
            // other errors
            if (error.response.data.errors) {
              alert(thisHandle.t("errors.site.sync_import") + " : " + error.message + "\n" + errMsg(error.response.data.errors));
            } else {
              alert(thisHandle.t("errors.site.sync_import") + " : " + error.message);
            }
          }
        
          throw error;
            
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log("Inside sites/SiteSelectImport.vue, onListCompanySites, error.request ==> ", error.request);
          alert("Error in sync: No response with request - " + error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Inside sites/SiteSelectImport.vue, onListCompanySites, error.message ==> ", error.message);
          alert("Setup error in site sync: " + error.message);
          // most likely bugs in code so throw the error back such that it can be viewed in browser console
          throw (error)
        }
      })
    },
    
    fullSiteAddress(site) {
      let address_array = [];
      if (site.address) {
        address_array = address_array.concat(site.address)
      }
      if (site.province) {
        address_array = address_array.concat(site.province)
      }
      if (site.post_code) {
        address_array = address_array.concat(site.post_code)
      }
      if (site.country_code) {
        address_array = address_array.concat(site.country_code)
      }
      return address_array.join(", ")
    }
  }
}
</script>